export const firebaseConfig = {
    apiKey: "AIzaSyDQOhW-bFf2RYU3jYUNJfkyKErJKTen3G4",
    authDomain: "prifact-78df6.firebaseapp.com",
    databaseURL: "https://prifact-78df6.firebaseio.com",
    projectId: "prifact-78df6",
    storageBucket: "prifact-78df6.appspot.com",
    messagingSenderId: "414373072766",
    appId: "1:414373072766:web:e5285841b32dfd9e63ed2f",
    measurementId: "G-XH5YNMDE9P"
};


